export default "/_next/static/b910a52e9ef04f3e7805a7a536e63b06.svg";